import React from 'react';
import DiscountTag from '../../atoms/DiscountTag';
import Counter from '../../atoms/Counter';
import { IAccessoriesDetail } from '../../../interface/accessories.interface';
import { calculateDiscount } from '../../../helpers/utils';
import { IBreadcrumbs } from '../Breadcrumbs';
import eventClickAccessories from '../../../helpers/emarsys/accessories/eventClickAccessories';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';

export default function PriceAccessories({
  quantity,
  setQuantity,
  accessoriesDetail,
  serviceType,
  impressionData,
}: {
  quantity: number;
  setQuantity: (val: number) => void;
  accessoriesDetail: IAccessoriesDetail;
  serviceType: 'tintouch' | 'accessories';
  impressionData?: {
    pageTitle: string;
    breadcrumbItems: IBreadcrumbs[];
    sku: string;
    skuPrice: string;
    carModel?: string[];
  };
}) {
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth) || {
    userData: null,
  };

  const eventClickEmarsys = (buttonName: string) =>
    eventClickAccessories(
      dispatch,
      impressionData?.sku,
      impressionData?.skuPrice,
      impressionData?.pageTitle,
      impressionData?.breadcrumbItems,
      userData?.customerNo,
      'subtotal',
      buttonName,
      impressionData?.carModel
    );

  return (
    <div className="flex justify-between">
      <div className="w-full">
        <div className="flex items-center">
          <p className="text-[18px] font-semibold text-supportiveRed mr-1.5 lg:text-xl lg:mr-2">
            {accessoriesDetail?.strikeThroughPrice
              ? accessoriesDetail?.strikeThroughPrice.formattedValue
              : accessoriesDetail?.price.formattedValue}
          </p>

          {accessoriesDetail?.strikeThroughPrice && (
            <DiscountTag classNames="flex justify-center items-center bg-[#BDF2EF] px-1 rounded-sm">
              <span className="text-xs font-normal text-reliableBlack">
                {calculateDiscount(
                  accessoriesDetail?.price.value,
                  accessoriesDetail?.strikeThroughPrice.value
                )}
              </span>
            </DiscountTag>
          )}
        </div>

        {accessoriesDetail?.strikeThroughPrice && (
          <p className="text-xs text-reliableBlack50 line-through lg:text-base lg:text-reliableBlack70">
            {accessoriesDetail.price.formattedValue}
          </p>
        )}
      </div>

      {serviceType === 'accessories' && (
        <Counter
          wrapperClassName="shrink-0"
          feature="ACCESSORIES"
          eventClickEmarsys={eventClickEmarsys}
          value={quantity}
          setValue={setQuantity}
        />
      )}
    </div>
  );
}
